import { useEffect, useState } from 'react'
import performanceReportsApi from 'services/api/performanceReports'

export default function useOTAConversionsData({
  isOtaOnly,
  activeYear,
  kind,
  parentChain,
  cityToFilter,
  groupToFilter,
  stateToFilter
}) {
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)
  const [response, setResponse] = useState()
  const [availableCities, setAvailableCities] = useState()
  const [hotelGroups, setHotelGroups] = useState()

  useEffect(() => {
    performanceReportsApi
      .monthlyOTAConversions({
        isOtaOnly,
        year: activeYear,
        kind,
        parentChainCode: parentChain,
        city: cityToFilter,
        groupId: groupToFilter,
        state: stateToFilter
      })
      .then(res => {
        setResponse(res)
        setAvailableCities(res.cities)
        setHotelGroups(
          res.hotelGroups.reduce((acc, hotelGroup) => {
            return { ...acc, [hotelGroup.id]: hotelGroup.name }
          }, {})
        )
        setIsErred(false)
      })
      .catch(() => setIsErred(true))
      .finally(() => setIsLoading(false))
  }, [
    activeYear,
    kind,
    parentChain,
    cityToFilter,
    stateToFilter,
    groupToFilter,
    isOtaOnly
  ])

  return {
    isLoading,
    isErred,
    response,
    availableCities,
    hotelGroups
  }
}
